import { Button, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { isStringNullOrEmpty } from '../utils/validators'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { backgroundStyle } from '../styles/background'
import { useRequests } from '../requests/useRequests'
import { RefreshActions } from '../state/refresh'
import { useDispatch } from 'react-redux'

interface PasswordsProps {
  username: string
  emailCode: string
}

const Passwords = ({ username, emailCode }: PasswordsProps): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const requestMaker = useRequests()
  const [password, setPassword] = useState('')
  const [passwordAgain, setPasswordAgain] = useState('')
  const [passwordError, setPasswordError] = useState<string | null>(null)
  const [passwordMatchError, setPasswordMatchError] = useState<string | null>(
    null
  )

  const handlePasswordsSubmit = async (): Promise<void> => {
    if (password !== passwordAgain) {
      setPasswordMatchError('Passwords should match')
      return
    }
    try {
      await requestMaker.changeForgottenPassword(username, emailCode, password)

      dispatch(
        RefreshActions.setToastMessage({
          message: 'Succesfully changed password'
        })
      )
      navigate('/login')
    } catch (e) {
      setPasswordError('Code or username is not correct')
    }
  }

  return (
    <>
      <form
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            void handlePasswordsSubmit()
          }
        }}
      >
        <Container component='main' maxWidth='xs'>
          <div style={backgroundStyle} />
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Typography component='h1' variant='h5'>
              New password
            </Typography>
            <TextField
              error={!isStringNullOrEmpty(passwordError)}
              variant='filled'
              type='password'
              helperText={passwordError}
              value={password}
              onChange={e => setPassword(e.target.value)}
              margin='normal'
              required
              fullWidth
              name='password'
              label='Password'
              id='password'
              autoComplete='password'
            />
            <TextField
              error={!isStringNullOrEmpty(passwordMatchError)}
              id='password-again'
              label='Password again'
              variant='filled'
              helperText={passwordMatchError}
              type='password'
              value={passwordAgain}
              onChange={e => setPasswordAgain(e.target.value)}
              required
              fullWidth
              name='password'
              autoComplete='password-again'
            />
            <Button
              type='submit'
              fullWidth
              variant='contained'
              sx={{ mt: 3, mb: 2 }}
              disabled={password === '' || passwordAgain === ''}
              onClick={e => {
                e.preventDefault()
                void handlePasswordsSubmit()
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  void handlePasswordsSubmit()
                }
              }}
              tabIndex={0}
            >
              Submit
            </Button>
          </Box>
        </Container>
      </form>
    </>
  )
}

export default Passwords
